import { useQuery } from '@tanstack/react-query';
import axios from '../../../utils/axios';
import { useIntl } from 'react-intl';
import { INVITE_ROLE } from './useSaveInvite';
import { useInviteTeamMember } from '../InviteTeamMemberContext';

export const useCurrentUserActions = (company, displayCompany) => {
  const intl = useIntl();
  const { setErrors } = useInviteTeamMember();

  return useQuery({
    enabled: !!company,
    queryKey: ['currentUserActions', company],
    queryFn: async () => {
      const encodedCompany = encodeURIComponent(company);
      const result = await axios.get(`/role?company=${encodedCompany}`);
      const actions = result.data.record.actions;

      if (!actions.includes(INVITE_ROLE)) {
        setErrors(intl.formatMessage({ id: 'error.addInvite' }, { displayCompany: displayCompany }));
      }

      return actions;
    },
    refetchOnWindowFocus: false
  });
};
